import { defineField, defineType } from 'sanity'
import getPageInfo, { seoGroup } from '../../objects/pageInfo'
import { PageBlockTypes } from '../../pageBlocks'

export default defineType({
  name: 'resourceCenter',
  title: 'Resource Center',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    defineField({
      title: 'Hero',
      name: 'hero',
      type: 'hero',
      group: 'content',
    }),
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      group: 'content',
    }),
    defineField({
      title: 'Page blocks',
      name: 'pageBlocks',
      type: 'array',
      of: [...PageBlockTypes],
      group: 'content',
    }),
    defineField({
      name: 'articleGroupsTitle',
      title: 'Article Groups Title',
      type: 'string',
      group: 'content',
    }),
    defineField({
      name: 'articleGroups',
      title: 'Article Groups',
      type: 'array',
      of: [
        {
          type: 'object',
          name: 'articleGroup',
          fields: [
            defineField({
              title: 'Blog',
              name: 'blog',
              type: 'object',
              fields: [
                defineField({
                  title: 'Section title',
                  name: 'title',
                  type: 'string',
                }),
                defineField({
                  name: 'category',
                  title: 'Category',
                  type: 'reference',
                  to: [{ type: 'articleCategory' }],
                }),
                defineField({
                  title: 'Articles',
                  name: 'articles',
                  type: 'array',
                  of: [
                    {
                      type: 'reference',
                      to: [{ type: 'article' }],
                      options: {
                        filter: ({ document, parentPath, parent }: any) => {
                          console.log(document, parentPath, parent)
                          return {
                            filter:
                              'showInResourceCenter && references($category)',
                            params: {
                              category: document.articleGroups.find(
                                (group: any) => group._key === parentPath[1]._key
                              )?.blog?.category?._ref,
                            },
                          }
                        },
                      },
                    },
                  ],
                  validation: (rule) =>
                    rule.unique().error('Each article should be unique'),
                }),
                defineField({
                  title: 'Button list',
                  name: 'buttonList',
                  type: 'buttonList',
                }),
              ],
            }),
          ],
          preview: {
            select: {
              title: 'blog.title',
            },
            prepare({ title = 'New Page' }) {
              return {
                title,
                subtitle: 'Article category',
              }
            },
          },
        },
      ],
      group: 'content',
    }),
    getPageInfo(),
  ],
  preview: {
    select: {
      pageInfo: 'pageInfo',
    },
    prepare({ pageInfo }) {
      const { title = 'New Page' } = pageInfo || {}
      return {
        title,
        subtitle: 'Resource Center',
      }
    },
  },
})